import React, { createContext } from 'react';

export interface ResourceSubmissionInfo {
  resource: any;
  setResource: React.Dispatch<React.SetStateAction<any | null>>;
  isPreviewing: boolean;
  setIsPreviewing: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
  bestOfYear?: number;
  submissionCategory?: { name: string; icon?: string | null };
  readOnly?: boolean;
}

export const ResourceSubmissionContext = createContext<ResourceSubmissionInfo>({
  resource: null,
  setResource: () => {},
  isPreviewing: false,
  setIsPreviewing: () => {},
  isError: false,
  setIsError: () => {},
  bestOfYear: undefined,
  readOnly: false,
});
